import moment from 'moment';

export default {
    required: {
        fn(value) {
            return value !== null && value !== '';
        },
        message: 'This field is required.',
    },

    date: {
        fn(value) {
            return moment(value, 'MM/DD/YYYY', true).isValid();
        },
        message: 'Please enter a date in the format MM/DD/YYYY',
    },

    phone: {
        fn(value) {
            const re = /\(\d{3}\) \d{3}-\d{4}/;
            return value && value.match(re);
        },
        message: 'Please enter a valid phone number.',
    },

    full_name: {
        fn(value) {
            return value.split(' ').length > 1;
        },
        message: 'Please enter a first and last name.',
    },

    email: {
        fn(value) {
            const re = /^([\w\.!#\$%\-+.'_]+@[A-Za-z0-9\-]+(\.[A-Za-z0-9\-]+)+)$/;
            return value.match(re);
        },
        message: 'Please enter a valid email address.',
    },

    min(number) {
        return {
            fn(value) {
                return value && value.length >= number;
            },
            message: `Minimum ${number} characters`,
        };
    },

    max(number) {
        return {
            fn(value) {
                return value && value.length <= number;
            },
            message: `Maximum ${number} characters`,
        };
    },

    alphaSpace: {
        fn(value) {
            const re = /[a-zA-Z-'\s]*/;
            return value && value.match(re);
        },
        message: 'Can only contain a-z, A-Z, and spaces.',
    },
};
